// @ts-nocheck

import React, { Component, Fragment } from 'react';

import { FormGroup, ControlLabel } from 'react-bootstrap';
import moment from 'moment';
import { connect } from 'react-redux';
import { AxiosError } from 'axios';

import {
  setDeletedUser,
  setFilterData,
  setFilterFlag,
} from '../actions/userActions';
import ItemActions from '../components/ItemActions/ItemActions';
import Succsess from '../components/stateMessage/Succsess';
import Error from '../components/stateMessage/Error';
import Modal from '../components/utils/ModalComponet';
import TopPanel from '../components/utils/TopPanel';
import UserStripeCustomers from '../components/stripe/UserStripeCustomers';
import CollapsableItem from '../components/utils/CollapsableItem';
import SimpleSelect from '../components/utils/FormWidgets/SimpleSelect';
import UserParties from '../components/users/UserParties/UserParties';
import Spinner from '../components/utils/Spinner';
import { getConfig } from '../config';
import { getMatchByPath, trackMixpanel } from '../infrastructure/utils/common';
import avatar from '../NoAvatar.jpg';
import { updatePartyMember } from '../services/PartiesService';
import * as Service from '../services/UsersService';
import '../styles/containers/User.css';
import AccountManagerDetailsSection, {
  AccountManagerDetailsUpdates,
} from '../components/user/AccountManagerDetailsSection';

const { batchWebURL } = getConfig();

class State {
  deactive = false;
  user = null;
  useravatar = '';
  openModal = false;
  backpage = false;
  partyforDeletion = '';
  errorMessage = '';
  isCurrentUser = false;
  userUpdated = false;
  serverError = false;
  isSendingStatus = false;

  accountManagerDetailsUpdates: AccountManagerDetailsUpdates = {};
}

class User extends Component {
  state = new State();

  async componentDidMount() {
    // eslint-disable-next-line react/prop-types
    const { history, currentUser } = this.props;
    try {
      // eslint-disable-next-line react/prop-types
      if (history.length > 2) {
        this.setState({ backpage: true });
      }

      // eslint-disable-next-line react/prop-types
      const match = getMatchByPath(history.location.pathname, '/users/:id');
      const { id } = match.params;
      const [user, parties] = await Promise.all([
        Service.getUser(id),
        Service.getUserParties(id),
      ]);

      // eslint-disable-next-line react/prop-types
      const isCurrentUser = user.Item && user.Item.id === currentUser.username;
      const { deactive } = this.state;
      if (!deactive) {
        this.setState({
          userInitialData: user.Item ? user.Item : 'not found',
          user: user.Item ? user.Item : 'not found',
          parties,
          useravatar: user.Item ? user.Item.photo : '',
          isCurrentUser,
        });
      }
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.log(error.message);
    }
  }

  componentWillUnmount() {
    // eslint-disable-next-line react/prop-types
    const { history, setFilter, activateFilter } = this.props;
    this.setState({ deactive: true });

    // eslint-disable-next-line react/prop-types
    if (history.location.pathname !== '/users') {
      activateFilter(false);
      setFilter(undefined);
    }
  }

  handleChangeRole = value => {
    this.setState(prevState => {
      const user = {
        ...prevState.user,
        role: value,
      };
      return { user };
    });
  };

  back = () => {
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;

    // eslint-disable-next-line react/prop-types
    history.goBack();
  };

  setDefaultAvatar = () => {
    this.setState({ useravatar: avatar });
  };

  openModal = () => {
    this.setState({ openModal: true });
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };

  deleteUser = async event => {
    event.preventDefault();

    const { user, parties } = this.state;

    // eslint-disable-next-line react/prop-types
    const { history, setDeleted, currentUser, mixpanel } = this.props;
    const badParty = parties.find(party => party.members.length >= 2);
    if (badParty) {
      this.setState({
        serverError: true,
        errorMessage: `Cannot delete this user, because he is member
         of ${badParty.partyName} party. Please delete him from parties members`,
        openModal: false,
      });
      setTimeout(this.hideMessage, 9 * 1000);
      return;
    }
    try {
      await Service.deleteUser(user.id);

      trackMixpanel('userDeleted', { userID: user.id }, currentUser, mixpanel);

      setDeleted(user.id);

      // eslint-disable-next-line react/prop-types
      setTimeout(history.push('/users'), 5 * 1000);
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        serverError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
        openModal: false,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  toParty = party => {
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;

    // eslint-disable-next-line react/prop-types
    history.push(party);
  };

  changeRole = (role, party) => {
    const { parties, user } = this.state;
    const member = parties
      .find(part => part.partyId === party)

      .members.find(memb => memb.memberId === user.id);
    member.memberRole = role;
    updatePartyMember(member);
    this.setState({ parties: [...parties] });
  };

  hideMessage = () => {
    this.setState({ userUpdated: false, serverError: false, errorMessage: '' });
  };

  handleSubmit = async event => {
    event.preventDefault();

    // eslint-disable-next-line react/prop-types
    const { currentUser, mixpanel } = this.props;

    const { user, userInitialData, accountManagerDetailsUpdates } = this.state;

    let accountManagerDetails = {};
    if (user.role === 'superAdmin') {
      const { avatar, ...restUpdates } = accountManagerDetailsUpdates;
      accountManagerDetails = {
        ...user.accountManagerDetails,
        ...restUpdates,
      };
      if (avatar) {
        const url = await Service.uploadAvatar(
          user.id,
          accountManagerDetailsUpdates.avatar.blob
        );

        accountManagerDetails.avatar = url;
      }
    }

    const isRoleChanged = userInitialData.role !== user.role;
    try {
      await Service.updateUser({
        ...user,
        accountManagerDetails:
          Object.keys(accountManagerDetails).length > 0
            ? accountManagerDetails
            : null,
      });
      if (isRoleChanged)
        trackMixpanel(
          'userRoleChanged',

          { userID: user.id, newRoleType: user.role },
          currentUser,
          mixpanel
        );
      this.setState({ userUpdated: true });
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        serverError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      this.setState({ userUpdated: true });
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  resetPassword = async email => {
    try {
      this.setState({ isSendingStatus: true });
      await Service.resetPassword(email);
      alert('Password has been reset');
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
    } finally {
      this.setState({ isSendingStatus: false });
    }
  };

  getUserActions = user => [
    {
      label: 'Send password reset email',
      image: { src: '/mail-black.png', alt: 'mail-black' },
      type: 'button',
      onClick: () => this.resetPassword(user.email),
      show: !!user.email,
    },
    {
      label: 'Copy user profile deep-link',
      image: { src: '/copy-square.png', alt: 'deep-link', width: '21px' },
      type: 'link',
      href: `${batchWebURL}/profile/${user.id}`,
      show: !!user.id,
    },
    {
      label: ' View app activity',
      image: { src: '/mixpanel-short.png', alt: 'mixpanel' },
      type: 'link',
      // eslint-disable-next-line max-len
      href: `https://mixpanel.com/report/1726253/view/18560/profile#distinct_id=${user.email}`,
      show: !!user.email,
    },
    {
      label: 'View email activity',
      image: { src: '/iterable-short.png', alt: 'iterable' },
      type: 'link',
      href: `https://app.iterable.com/users/profiles/${user.email}`,
      show: !!user.email,
    },
  ];

  handleAccountManagerDetailsChange = async (
    updates: AccountManagerDetailsUpdates
  ) => {
    this.setState(prev => ({
      accountManagerDetailsUpdates: {
        ...prev.accountManagerDetailsUpdates,
        ...updates,
      },
    }));
  };

  render() {
    const {
      user,

      parties,
      userUpdated,
      backpage,
      openModal,
      errorMessage,
      isCurrentUser,
      serverError,
      useravatar,
      isSendingStatus,
    } = this.state;
    const userloaded = user != null;
    if (!userloaded) {
      return <Spinner />;
    }
    if (user === 'not found') {
      return <h2>User not Found</h2>;
    }
    return (
      <Fragment>
        <Modal
          open={openModal}
          closeModal={this.closeModal}
          cancel={this.closeModal}
          action={this.deleteUser}
          actionButtonText='Delete User'
        >
          <div style={{ marginBottom: '40px' }}>
            Are you sure you want to delete this user? You cannot undo deletion.
          </div>
        </Modal>
        {userUpdated && <Succsess text='user updated' />}
        {serverError && <Error text={`${errorMessage}`} />}
        <TopPanel isDetailsPage>
          <div
            type='button'
            className='btn-nav back'
            onClick={backpage ? this.back : undefined}
            style={{ marginLeft: '15px' }}
            aria-label='left Align'
          >
            {backpage && (
              <>
                <i
                  className='fas fa-arrow-left'
                  style={{ paddingRight: '8px' }}
                />
                <span className='page-back'>Back</span>
              </>
            )}
            <span className='page-back-mobile'>{user.name}</span>
          </div>
          <div className='page-actions'>
            <button
              type='button'
              onClick={this.openModal}
              className='btn btn-dang'
              style={{ marginRight: '10px' }}
            >
              Delete User
            </button>
            <button
              type='button'
              onClick={this.handleSubmit}
              className='btn btn-primary pull-right'
            >
              Update
            </button>
          </div>
        </TopPanel>
        <div className='data-container'>
          <div className='data-box'>
            <div className='media' style={{ overflow: 'inherit' }}>
              <div className='media-left'>
                <img
                  alt=''
                  src={useravatar}
                  className='align-self-start mr-3'
                  onError={this.setDefaultAvatar}
                  style={{ width: '200px', height: '200px' }}
                />
              </div>
              <div className='media-body' style={{ overflow: 'inherit' }}>
                <h2 className='media-heading'>
                  <b className='user-name'>{user.name}</b>
                  {(user.email || user.id) && (
                    <ItemActions actions={this.getUserActions(user)} />
                  )}
                </h2>
                <h4 className='user-email'>{user.email}</h4>
                <h4 className='user-joined-date'>
                  <i className='fas fa-calendar-alt' />
                  Joined Date: {moment(user.createDate).format('MM/DD/YY')}
                </h4>
                {!isCurrentUser && (
                  <FormGroup
                    controlId='role'
                    className='col-md-2 col-sm-4 col-xs-4 user-role-selector'
                    style={{ paddingLeft: '0px' }}
                  >
                    <ControlLabel>Role</ControlLabel>
                    <SimpleSelect
                      onChange={this.handleChangeRole}
                      value={user.role}
                      data={[
                        { value: 'superAdmin', label: 'Admin' },
                        { value: 'user', label: 'BACHer' },
                        { value: 'vendor', label: 'Vendor' },
                      ]}
                    />
                  </FormGroup>
                )}
              </div>
            </div>
            {user.email && (
              <p className='user-email user-email-mobile'>
                <i className='fas fa-envelope' />
                {user.email}
              </p>
            )}
            {user.phone && (
              <p className='user-phone user-phone-mobile'>
                <i className='fas fa-phone' />
                {<a href={`tel:+${user.phone}`}>{user.phone}</a>}
              </p>
            )}
          </div>
          {user.role === 'superAdmin' && (
            <AccountManagerDetailsSection
              details={user.accountManagerDetails || {}}
              onChange={this.handleAccountManagerDetailsChange}
            />
          )}

          {parties.length > 0 && (
            <div className='data-box'>
              <h4 className='header'>Parties</h4>
              <CollapsableItem isExpanded>
                <UserParties
                  content={parties}
                  handleOnClick={this.toParty}
                  user={user}
                  changeRole={this.changeRole}
                />
              </CollapsableItem>
            </div>
          )}
          <div className='data-box'>
            <h4
              className='header col-md-6 col-sm-6 col-xs-6'
              style={{ paddingLeft: '0px' }}
            >
              Stripe Charges
            </h4>
            <div className='clearfix' />
            <CollapsableItem isExpanded>
              {<UserStripeCustomers userId={user.id} />}
            </CollapsableItem>
          </div>
          <div className='page-actions-mobile'>
            <button
              type='button'
              onClick={this.openModal}
              className='btn btn-dang'
              style={{ marginRight: '10px' }}
            >
              Delete User
            </button>
            <button
              type='button'
              onClick={this.handleSubmit}
              className='btn btn-primary pull-right'
            >
              Update
            </button>
          </div>
        </div>
        {isSendingStatus && (
          <div className='sending-status-loader'>
            <Spinner />
          </div>
        )}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.users.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setFilter: data => dispatch(setFilterData(data)),
    activateFilter: data => dispatch(setFilterFlag(data)),
    setDeleted: user => dispatch(setDeletedUser(user)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(User);
